import $ from 'jquery';


$(window).on('load', function () {
    var cwmPageSize = parseInt($('.cwm-fa-filter-content').first().data('page-size'));
    var cwmCurrentVisibleItems = cwmPageSize;
    var cwmTotalFiltered = 0;

    function cwmFilter(e, scroll) {
        var $allElements = $('.cwm-fa-filter-content').find('.cwm-fa-filter-content__item');
        cwmTotalFiltered = $allElements.length;
        var $visibleElements = $allElements.slice(0, cwmCurrentVisibleItems);
        var scrollTo = $(".show-more-wrapper #showMore");
        if(scrollTo.length) {
            var newTop = scrollTo.offset().top;
        }
        var x = 0;
        $('.cwm-fa-filter-content').find('.cwm-fa-filter-content__item').hide();
        $visibleElements.fadeIn(10, function() {
            if(x < $visibleElements.length - 1){
                x++;
            }
            else
            {
                if(scroll)
                {
                    $('body,html').animate({ scrollTop: newTop }, 500);
                }
            }
        })
    }

    function cwmShowHideButtons() {
        if(cwmCurrentVisibleItems >= cwmTotalFiltered)
        {
            $('.show-more-wrapper #showMore').hide();
        }
        else
        {
            $('.show-more-wrapper #showMore').show();
        }
    }

    $('.show-more-wrapper #showMore').click(function (e) {
        cwmCurrentVisibleItems += cwmPageSize;
        cwmFilter(e, true);
        cwmShowHideButtons();

    });
    cwmFilter();
    cwmShowHideButtons();
});


// WEBPACK FOOTER //
// ./components/cwm-event-filter/scripts/cwm-event-filter-card-pagination.js